// Shared accent → Tailwind class map for the inline-SVG chart primitives
// (Sparkline, ColumnChart, Histogram, TimeBand). No chart library anywhere
// in this app: four hand-rolled SVGs cost nothing in the bundle, scale
// cleanly on a phone, and can carry a real aria-label — the same idiom
// BarRow.svelte already uses.
//
// The class strings are literals so Tailwind's content scanner emits them.
// Colours come from the existing theme tokens, so both themes work without
// a second palette.

export type ChartAccent = 'teal' | 'lime' | 'navy' | 'amber';

type AccentClasses = { stroke: string; fill: string; area: string; text: string };

const ACCENTS: Record<ChartAccent, AccentClasses> = {
  teal: { stroke: 'stroke-toyama-teal', fill: 'fill-toyama-teal', area: 'fill-toyama-teal/15', text: 'text-toyama-teal' },
  lime: { stroke: 'stroke-toyama-lime', fill: 'fill-toyama-lime', area: 'fill-toyama-lime/20', text: 'text-toyama-lime' },
  navy: { stroke: 'stroke-navy', fill: 'fill-navy', area: 'fill-navy/10', text: 'text-navy' },
  amber: { stroke: 'stroke-warning', fill: 'fill-warning', area: 'fill-warning/15', text: 'text-warning' }
};

export function accentClasses(accent: string | undefined): AccentClasses {
  return ACCENTS[(accent ?? 'teal') as ChartAccent] ?? ACCENTS.teal;
}

/** Axis captions for a series: first, middle and last label only. A 30-point
    series with 30 captions under it is a grey smear, not an axis. */
export function edgeLabels(labels: string[]): string[] {
  if (labels.length <= 3) return labels;
  return [labels[0], labels[Math.floor(labels.length / 2)], labels[labels.length - 1]];
}
